import { BehaviorSubject } from "rxjs";
import { Msisdn } from "@/models/msisdn";
import axios from "@/services/axios";

export interface MsisdnState {
  data: Msisdn[];
  isLoading: boolean;
  dataLoaded: boolean;
}

const initialState: MsisdnState = {
  data: [],
  isLoading: false,
  dataLoaded: false,
};

class MsisdnService {
  private readonly _msisdns = new BehaviorSubject<MsisdnState>(initialState);

  readonly msisdns$ = this._msisdns.asObservable();

  get msisdns(): MsisdnState {
    return this._msisdns.getValue();
  }

  set msisdns(val: MsisdnState) {
    this._msisdns.next(val);
  }

  fetchAllMsisdns(forceFetch = false): void {
    if (forceFetch) {
      this.msisdns = {
        data: [],
        isLoading: true,
        dataLoaded: false,
      };
    }
    if (!this.msisdns.dataLoaded) {
      this.msisdns = {
        ...this.msisdns,
        isLoading: true,
      };
      axios.get("/api/msisdns").then(
        (response) => {
          this.msisdns = {
            data: response.data,
            isLoading: false,
            dataLoaded: true,
          };
        },
        () => {
          this.msisdns = {
            data: [],
            isLoading: false,
            dataLoaded: true,
          };
        },
      );
    }
  }

  fetchAllMsisdn(ownedMsisdns: boolean = false): Promise<void> {
    return axios.get("/api/msisdns", {
      params: { ownedMsisdns },
    });
  }

  createMsisdn(msisdn: Msisdn) {
    return axios.post("/api/msisdns", msisdn);
  }

  updateMsisdn(id: string, msisdn: any) {
    return axios.put(`/api/msisdns/${id}`, msisdn);
  }

  getMsisdns(
    pageIndex: number,
    pageSize: number,
    sortField?: string,
    sortOrder?: string,
    filter?: string,
    type?: string,
  ): Promise<Msisdn[]> {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";

    let param: any = {
      page: pageIndex,
      size: pageSize,
      sort,
    };
    if (filter) {
      param["filter"] = filter;
    }
    if (type) {
      param["type"] = type;
    }
    return axios.get(`/api/msisdns/organisation`, {
      params: param,
    });
  }

  getUsers(msisdnAddress: any): Promise<any> {
    return axios.get(`/api/msisdns/${msisdnAddress}`);
  }

  assignUser(userData: any, msisdnId: any): Promise<any> {
    return axios.put(`/api/msisdns/${msisdnId}/access`, userData);
  }
}
export { initialState as initialMsisdnState };
export const msisdnServices = new MsisdnService();
